// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__21rfu","ranges":"BmiRanges_ranges__1QKhP"};